import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const SPORT_COLORS = {
  football: "#047857",
  basketball: "#EA580C",
  athletics: "#2563EB",
  combat: "#DC2626",
  handball: "#4F46E5",
  volleyball: "#0891B2",
  women: "#9333EA",
  more: "#475569",
};

export const sportColor = (s) => SPORT_COLORS[s] || "#475569";
export const sportLabel = (s) => (s === "more" ? "More Sports" : s === "women" ? "Women" : (s || "").charAt(0).toUpperCase() + (s || "").slice(1));

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtDate(iso, withTime = true) {
  if (!iso) return "TBD";
  const d = new Date(iso);
  const date = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  return withTime ? `${date} · ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}` : date;
}

export const FLAG = "https://flagcdn.com/w40/cm.png";
export const PLACEHOLDER = "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?crop=entropy&cs=srgb&fm=jpg&q=60&w=600";
export const onImgError = (e) => { if (e.currentTarget.src !== PLACEHOLDER) { e.currentTarget.src = PLACEHOLDER; } };
